class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    upsellplusapp.init_drawer_offer();
    this.cartNotification.setActiveElement(document.activeElement);

    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const processedData = processProperties(JSON.parse(serializeForm(this.form)))

    const body = JSON.stringify({
      ...processedData,
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

function processProperties(obj) {
  const nestedObj = {}

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const match = key.match(/^properties\[([^[\]]+)\]$/)
      if (match) {
        const nestedKey = match[1]
        nestedObj.properties = nestedObj.properties || {}
        nestedObj.properties[nestedKey] = obj[key]
      } else {
        nestedObj[key] = obj[key]
      }
    }
  }

  return nestedObj
}

customElements.define('product-form', ProductForm);
